export default {
      id: "clarityFilterGridLine-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#clarityFilterGridLine-usage",
      toString: function () {
        return this.url;
      }
    }